import React from "react";
import "./ProgressBox.css";
import styled, {css} from "styled-components";
import {useSelector} from "react-redux";
import loadingBoxImage from "images/common/loading-box.png";

const DarkBackground = styled.div`
  display: none;
  position: fixed;
  z-index: 30;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);

  ${props =>
    props.disappear &&
    css`
      display: block;
    `}
`;

function ProgressBox({percentage, loaded, processName}) {
  const isPlayMode =
    useSelector(state => {
      return state.mode.studioMode;
    }) === "play";
  const progress = document.querySelector(".progress-bar");
  if (progress) {
    progress.style.width = percentage + "%";
  }

  if (loaded === true) {
    return <></>;
  }
  if (processName === "SCENE_FETCH") {
    return (
      <div className="playmode_background">
        <div className="loading_bar_background">
          <p className={`progress_bar_text ${isPlayMode && "play_mode"}`}>
            Loading ... {percentage !== undefined ? parseInt(percentage) + "%" : ""}
          </p>
          <div className="progress-bar-container">
            <div className="progress-bar"></div>
          </div>
        </div>
      </div>
    );
  } else if (processName === "SERVER_SCENE_FETCH") {
    return (
      <div className="playmode_background">
        <div className="loading_bar_background">
          <p className={`progress_bar_text ${isPlayMode && "play_mode"}`}>Connecting to server ... {parseInt(percentage)}%</p>
          <div className="progress-bar-container">
            <div className="progress-bar"></div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <DarkBackground disappear={!loaded}>
        <div className="progress_box_background">
          <img src={loadingBoxImage} className={`progress_box_img ${isPlayMode && "play_mode"}`} alt="loading"></img>
          <p className={`progress_box_text ${isPlayMode && "play_mode"}`}>{percentage}%</p>
        </div>
      </DarkBackground>
    );
  }
}

export default ProgressBox;
